/**
 * Kundens LAN-adresser <-> sitets alias (beslutning 094).
 *
 * Montøren kan ikke skrive kundens egen adresse (fx 10.122.1.50): mange kunder bruger samme LAN. Hvert site har
 * derfor et unikt alias på gatewayen (fx 10.52.0.0/24), og routeren oversætter sidste ciffer 1:1.
 * Samme regel står i backend `VpnLan.ToAlias` - hold de to ens.
 */

function parse(address: string): number[] | null {
  const parts = address.trim().split('.')
  if (parts.length !== 4) return null
  const bytes = parts.map((p) => (/^\d{1,3}$/.test(p) ? Number(p) : NaN))
  return bytes.every((b) => Number.isInteger(b) && b >= 0 && b <= 255) ? bytes : null
}

function network24(cidr: string): number[] | null {
  const [address, prefix] = cidr.split('/')
  const bytes = prefix === '24' ? parse(address) : null
  return bytes && bytes[3] === 0 ? bytes : null
}

/** "10.122.1.50" -> "10.52.0.50". Null, hvis adressen ikke ligger på kundens LAN. */
export function toAlias(customerAddress: string, customerLan: string, lanPrefix: string): string | null {
  const address = parse(customerAddress)
  const lan = network24(customerLan)
  const alias = network24(lanPrefix)
  if (!address || !lan || !alias || address.slice(0, 3).join('.') !== lan.slice(0, 3).join('.')) return null
  return [...alias.slice(0, 3), address[3]].join('.')
}

/** "10.52.0.0/24" + "10.122.1.0/24" -> eksempel til visning: "10.122.1.50 = 10.52.0.50". */
export function aliasExample(customerLan: string, lanPrefix: string, host = 50): string | null {
  const lan = network24(customerLan)
  if (!lan) return null
  const customer = [...lan.slice(0, 3), host].join('.')
  const alias = toAlias(customer, customerLan, lanPrefix)
  return alias ? `${customer} = ${alias}` : null
}
